module.exports = __webpack_public_path__ + "img/electric_enabled_selected.e994f2d1.svg";